import { Text } from '@morressier/ts';
import * as Styles from './styles';

const truncateText = (text: string, pos = 120) => {
  if (text.length >= pos) {
    return `${text.slice(0, pos)}...`;
  }
  return text;
};

const getInitials = (fullName: string) => {
  const names = (fullName && fullName.split(' ')) || [''];
  let initials = names[0].substring(0, 1).toUpperCase();

  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase();
  }

  return initials;
};

export const ExhibitorItem: React.FC<{ data: Exhibitor; onClick: () => void }> = ({
  data,
  onClick,
}) => {
  const { brand_theme, name, description } = data;

  // hack to remove broken image icon
  const getAs = (): { [x: string]: string } | undefined =>
    !brand_theme?.banner_url ? { as: 'div' } : undefined;

  return (
    <Styles.ExhibitorCard onClick={onClick}>
      <Styles.ExhibitorBanner
        {...getAs()}
        src={brand_theme?.banner_url}
        alt={name}
        loading="lazy"
      />
      {brand_theme?.logo_url ? (
        <Styles.ExhibitorLogo src={brand_theme?.logo_url} alt="Exhibitor Logo" loading="lazy" />
      ) : (
        <Styles.ExhibitorLogo as="div">
          <Text>{getInitials(name)}</Text>
        </Styles.ExhibitorLogo>
      )}
      <Styles.ExhibitorCardContent>
        <Text color="grey">{String('Exhibitor').toUpperCase()}</Text>
        <Text fontWeight="bold" truncate>
          {name}
        </Text>
        <Text>{truncateText(description)}</Text>
      </Styles.ExhibitorCardContent>
    </Styles.ExhibitorCard>
  );
};
